import './index-metric-health.style.scss'

class indexMetricHealthController {
    constructor() {
        'ngInject';

        console.log('---- in indexMetricHealth', this)
    }
}

export default indexMetricHealthController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-health/index-metric-health.controller.js